import { refreshTokenAPI } from "../../processes/api/login";
import { addSecondsToCurrentTime } from "./addSecondsToCurrentTime";
import { deleteAuthToken } from "./deleteAuthToken";
import { getAuthToken } from "./getAuthToken";
import { secondsToMileSeconds } from "./secondsToMileSeconds";
import { setAuthToken } from "./setAuthToken";

interface IAuthData {
  tokenLifeTime: number;
  refreshTokenLifeTime: number;
}

export const checkTokenAndRefresh = async () => {
  const authInfo: string = getAuthToken();

  if (authInfo) {
    const data: IAuthData = JSON.parse(authInfo);
    const tokenLifeTime = data.tokenLifeTime;
    const refreshTokenLifeTime = data.refreshTokenLifeTime;
    const currentTimestamp = new Date().getTime();
    // Проверка времени жизни refreshToken
    if (refreshTokenLifeTime > currentTimestamp) {
      console.warn("RefreshToken действителен.");
      // Проверка времени жизни токена
      if (tokenLifeTime > currentTimestamp) {
        console.warn("Токен действителен.");
      } else {
        try {
          const newTokenData = await refreshTokenAPI();
          const newToken = newTokenData.data.authData.token;
          const newTokenLife = newTokenData.data.authData.tokenExpiresIn - 30;
          const newTokenLifeTime = addSecondsToCurrentTime(
            secondsToMileSeconds(newTokenLife)
          );
          const newAuthInfo = {
            ...data,
            token: newToken,
            tokenLifeTime: newTokenLifeTime,
          };
          setAuthToken(JSON.stringify(newAuthInfo));
        } catch (error) {
          console.error("Failed to refresh token:", error);
          throw error;
        }
      }
    } else {
      console.error("RefreshToken истек.");
      deleteAuthToken();
      window.location.href = "/login";
    }
  }
};
